//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DonationsListItem from "@/components/objects/public/DonationsListItem.vue";

export default {
  name: "Donations",
  components: { DonationsListItem },
  layout: "public_new",
  async asyncData({ store, $axios }) {
    return {
      categories: await store.dispatch('categories/getNavTree'),
      levels: await $axios.$get(`${process.env.BASE_URL_V2}/public/footer/supporters/`)
        .then(r => r.levels),
    }
  },
  data() {
    return {
      categories: [],
      levels: [],
    }
  },
  head() {
    return {
      title: 'Благотворители'
    }
  },
  computed: {
    getLevels() {
      let items = [];
      let isManyDonations;
      for (let i = 0; i < this.levels.length; i++) {
        items.push(...this.levels[i].items);
        if (items > 7) {
          isManyDonations = true;
          break;
        }
      }
      if (isManyDonations) {
        return this.levels;
      } else {
        return [{
          icon: this.levels[0].icon,
          title: this.levels[0].title,
          items: items,
        }]
      }
    }
  },
}
